import { PrivilegeCode } from "../services/PrivilegesServices-dto";

export function getPrivilege(
  user: { excludedPrivileges?: PrivilegeCode[] },
  privilege: PrivilegeCode
): boolean {
  return !user.excludedPrivileges || !user.excludedPrivileges.includes(PrivilegeCode[privilege]);
}
